import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M3.742 10.27c.607-3.417 3.694-6.02 7.417-6.02 2.647 0 4.972 1.317 6.312 3.302 3.17.048 5.72 2.538 5.72 5.599 0 3.09-2.6 5.599-5.813 5.599H5.361c-2.516 0-4.55-1.965-4.55-4.383 0-1.872 1.216-3.469 2.931-4.098m7.417-4.52c-3.087 0-5.63 2.263-5.933 5.166a.76.76 0 0 1-.588.652c-1.3.312-2.267 1.446-2.267 2.799 0 1.594 1.341 2.883 2.99 2.883h12.017c2.345 0 4.25-1.833 4.25-4.1s-1.905-4.099-4.25-4.099q-.146 0-.288.01a.79.79 0 0 1-.733-.382c-1.024-1.75-2.97-2.929-5.198-2.929"
      clipRule="evenodd"
    />
  </>
);

const Weather26 = Icon('weather-26', svgContents);

export default Weather26;
